import initHelpHeroLib, { HelpHero } from 'helphero';

export type HelpHeroUserTraits = {
    email: string;
    language: string;
    is_from_customer: boolean;
    customer_name?: string;
    host: string;
    tenant: string;
    has_access_to_customer_portal: boolean;
    has_access_to_source_to_contract: boolean;
    has_full_manufacturing_access: boolean;
    has_customers: boolean;
    client_type: string;
    is_closed_beta_tester: boolean;
};

/** `undefined` until `initHelpHero()`; components call `helpHero?.update()` for tour state. */
export let helpHero: HelpHero | undefined = undefined;

const HELPHERO_APP_ID = 'WIicqzvzCa';

export function initHelpHero(userId: string, traits: HelpHeroUserTraits): void {
    if (!helpHero) {
        helpHero = initHelpHeroLib(HELPHERO_APP_ID);
    }
    helpHero.identify(userId, traits);
}
